/* eslint-disable no-magic-numbers */
import { resolutionFullHD, fontFamily } from './constants';
import { getRelX } from './utils/getRel';
import { scaleToCover } from './utils/scaleTo';

export default function UserAvatar(resources, item, avatarSize, fontSize) {
	avatarSize = avatarSize ? avatarSize : getRelX(0.1);
	fontSize = fontSize ? fontSize : 20;
	const cont = new PIXI.Container();
	const avatarCont = new PIXI.Container();
	const avatar = new PIXI.Sprite(resources[ item.avatar ].texture);
	const avatarMask = new PIXI.Graphics();
	avatarMask.beginFill(0x00FF00, 1);
	avatarMask.drawCircle(0, 0, avatarSize / 2);
	cont.anchor = new PIXI.Point(0.5, 0.5);
	avatarCont.anchor = new PIXI.Point(0.5, 0.5);
	avatarMask.anchor = new PIXI.Point(0.5, 0.5);
	avatar.anchor = new PIXI.Point(0.5, 0.5);
	scaleToCover(avatar, avatarSize, avatarSize);
	const relFontSize = fontSize * (window.rendererWidth / resolutionFullHD);
	const text = new PIXI.Text(item.name, {
		fontWeight: 'normal',
		fontSize: relFontSize + 'px',
		fontFamily: fontFamily,
		fill: '#FFFFFF',
		align: 'center',
		wordWrap: true,
		wordWrapWidth: avatarSize * 1.6,
	});
	text.anchor = new PIXI.Point(0.5, 0);
	text.position = new PIXI.Point(0, avatarSize * 0.6);
	avatarCont.addChild(avatar);
	avatarCont.addChild(avatarMask);
	avatarCont.mask = avatarMask;
	avatarCont.cacheAsBitmap = true;
	cont.addChild(avatarCont);
	cont.addChild(text);

	return cont;
}
